import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {quizPickerEdit_template} from "./quizPickerEdit_template";
import {quizPickerView_template} from "./quizPickerView_template";

declare var ko: any;

export class quizPicker_template extends vnTemplate {
    protected filterSimple: filterSimple_template;
    public quizEdit: quizPickerEdit_template;
    public quizView: quizPickerView_template;
    protected quizLoadEnabled: boolean = false;
    protected quizNextpageRequested: boolean = false;
    protected quizScrollContainer: HTMLElement | null = null;
    protected quizScrollHandler: EventListener | null = null;
    protected quizScrollDebounceTimeout: number | null = null;
    protected target: any;

    protected getTemplateHtml(): string {
        return /* html */ `
      <div class="w-lightbox w-picker" data-bind="css: { 'is-visible': isShown }">
        <div class="lightbox-content picker">
          <div class="picker-header w-justify">
            <div class="w-left"></div>
            <div class="w-center">
              <span class="picker-header-title icon i-poll">Quiz Search</span>
            </div>
            <div class="w-right">
              <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
            </div>
          </div>

          <div class="picker-body">
            <div class="list-header w-justify">
              <div class="w-left">
                <button class="btn icon i-poll" type="button" data-bind="event: { click: onClickAddQuiz }">Create Quiz</button>
                <button class="btn secondary icon i-poll" type="button" data-bind="event: { click: onClickGenerateAndEditQuiz }">Generate & Edit</button>
                <button class="btn secondary icon i-ins" type="button" data-bind="event: { click: onClickGenerateAndInsertQuiz }">Generate & Insert</button>
              </div>
              <div class="w-right">
                ${this.filterSimple.getHtmlBuild()}
              </div>
            </div>

            <div class="w-picker-list" id="quiz-results-list" style="max-height: calc(100vh - 220px); overflow-y: auto; min-height: 0;">
              <div class="" data-bind="css: { 'is-visible': quizResults().length == 0 && !isLoading(), 'w-msg': (quizResults().length > 0 || isLoading()) }">
                <p>No Results Found</p>
              </div>

              <ul class="picker-list" id="quiz-picker-list" data-bind="foreach: quizResults, css: { loading: isLoading }" style="height: auto; min-height: 12rem;">
                <li class="picker-item icon">
                  <button class="btn-zone view" title="view quiz" type="button" data-bind="event: { click: $parent.onClickQuiz }"><span>view quiz</span></button>
                  <button class="btn-zone icon i-edit" style="right: 42px; bottom: 6px; z-index: 69; font-size: 16px;" title="Quick Edit Quiz" type="button" data-bind="event: { click: $parent.onClickQuickEditQuiz }"><span>edit quiz</span></button>
                  <button class="btn-zone icon i-ins" style="right: 6px; bottom: 6px; z-index: 69; font-size: 16px;" title="Quick Insert Quiz" type="button" data-bind="event: { click: $parent.onClickQuickInsertQuiz }"><span>insert quiz</span></button>
                  <div class="w-info">
                    <strong data-bind="text: title"></strong>
                    <span>
                      <span data-bind="text: numberOfQuestions"></span> questions
                      &nbsp;|&nbsp;
                      <span data-bind="text: numberOfRespondents"></span> respondents
                    </span>
                    <span data-bind="visible: dateCreated, text: dateCreated.slice(0, 16)"></span>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          ${this.quizView.getHtmlBuild()}
          ${this.quizEdit.getHtmlBuild()}
        </div>
      </div>
    `;
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            isShown: ko.observable(false),
            isLoading: ko.observable(false),
            target: ko.observable(""),
            quizResults: ko.observableArray([]),
            quizElement: ko.observable(null),
            isQuizDynamicPlacementOnByDefault: ko.observable(false),
            isQuizDynamicPlacement: ko.observable(false),
            quizPagination: {
                pageNumber: ko.observable(1),
                pageMax: ko.observable(1),
                itemPerPage: 54,
            },
            orderBy: ko.observable("dateCreated"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateCreated_DESC"),
            onClickCancel: function () {
                self.hide();
            },
            onClickQuiz: function (quiz) {
                self.onClickQuiz(quiz);
            },
            onClickQuickEditQuiz: function (quiz) {
                self.onClickQuickEditQuiz(quiz);
            },
            onClickQuickInsertQuiz: function (quiz) {
                self.onClickQuickInsertQuiz(quiz);
            },
            onClickAddQuiz: function () {
                self.onClickAddQuiz();
            },
            onClickGenerateAndEditQuiz: function () {
                self.onClickGenerateAndEditQuiz();
            },
            onClickGenerateAndInsertQuiz: function () {
                self.onClickGenerateAndInsertQuiz();
            },
        };
    }

    protected initPartial(): void {
        this.quizView = new quizPickerView_template(
            "quizPickerView",
            this.getTemplateViewModel(),
            this.caller
        );
        this.quizView.setParent(this);

        this.quizEdit = new quizPickerEdit_template(
            "quizPickerEdit",
            this.getTemplateViewModel(),
            this.caller
        );
        this.quizEdit.setParent(this);

        this.filterSimple = new filterSimple_template(
            "filterQuizSearch",
            this.getTemplateViewModel(),
            this
        );

    }

    protected getTemplateName(): string {
        return "quizPicker-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    public getViewModelForRequest() {
        return {
            filters: {
                keywords: this.getTemplateViewModel().filterQuizSearch.filterKeyword,
            },
            pagination: this.getTemplateViewModel().quizPagination,
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            isQuizDynamicPlacementOnByDefault: this.getTemplateViewModel().isQuizDynamicPlacementOnByDefault,
        };
    }

    public resetPagination() {
        this.disableQuizWaypoint();
        this.getTemplateViewModel().quizPagination.pageNumber(1);
        this.getTemplateViewModel().quizPagination.pageMax(1);
        this.getTemplateViewModel().quizResults([]);
        this.quizNextpageRequested = false;

        const div = document.getElementById("quiz-results-list");
        if (div) {
            div.scrollTop = 0;
        }
    }

    public setSimpleFilterKeyword(filterKeyword) {
        this.getTemplateViewModel().filterQuizSearch.filterKeyword(filterKeyword || "");
    }

    public setTarget(target) {
        this.target = target;
        this.getTemplateViewModel().target(target);
    }

    public setQuizElement(quizElement): void {
        this.getTemplateViewModel().quizElement(quizElement);
    }

    public getQuizElement() {
        return this.getTemplateViewModel().quizElement();
    }

    public setIsQuizDynamicPlacementOnByDefault(isQuizDynamicPlacementOnByDefault): void {
        const value = !!isQuizDynamicPlacementOnByDefault;
        this.getTemplateViewModel().isQuizDynamicPlacementOnByDefault(value);
        this.quizView.setIsQuizDynamicPlacementOnByDefault(value);
        this.quizEdit.setIsQuizDynamicPlacementOnByDefault(value);
    }

    public setIsQuizDynamicPlacement(isQuizDynamicPlacement): void {
        const value = !!isQuizDynamicPlacement;
        this.getTemplateViewModel().isQuizDynamicPlacement(value);
        this.quizView.setIsQuizDynamicPlacement(value);
        this.quizEdit.setIsQuizDynamicPlacement(value);
    }

    public getIsQuizDynamicPlacement(): boolean {
        return !!this.getTemplateViewModel().isQuizDynamicPlacement();
    }

    protected getQuizDynamicPlacementConfigDefault(): boolean {
        try {
            const settings = this.caller.articlesEdit.getTemplateViewModel().articlePageSettings();
            return !!(settings && settings.isQuizDynamicPlacementOnByDefault);
        } catch (e) {
            return false;
        }
    }

    protected getInitialQuizDynamicPlacement(): boolean {
        const elementToReplace = this.getQuizElement();
        if (elementToReplace && elementToReplace.getAttribute("data-dynamic-placement") !== null) {
            return elementToReplace.getAttribute("data-dynamic-placement") === "1";
        }

        return this.getQuizDynamicPlacementConfigDefault();
    }

    protected refreshQuizDynamicPlacementDefaults(): void {
        const isQuizDynamicPlacementOnByDefault = this.getQuizDynamicPlacementConfigDefault();
        this.setIsQuizDynamicPlacementOnByDefault(isQuizDynamicPlacementOnByDefault);
        this.setIsQuizDynamicPlacement(this.getInitialQuizDynamicPlacement());
    }

    public getIdBrand(): number | null {
        const appZone = this.caller.getVnAppZone ? this.caller.getVnAppZone() : null;
        if (appZone && appZone.app && appZone.app.params && appZone.app.params.idBrand) {
            return Number(appZone.app.params.idBrand);
        }

        return this.caller.getBrandId ? Number(this.caller.getBrandId()) : null;
    }

    public setQuizResults(quizzes) {
        if (this.getTemplateViewModel().quizPagination.pageNumber() == 1) {
            this.getTemplateViewModel().quizResults([]);
        }

        if ((quizzes || []).length > 0) {
            const quizResults = this.getTemplateViewModel().quizResults().concat(quizzes);
            this.getTemplateViewModel().quizResults(quizResults);
            this.quizNextpageRequested = false;
            this.enableQuizWaypoint();
            return;
        }

        this.quizNextpageRequested = false;
    }

    public setQuizzesPagination(totalPage, currentPage) {
        this.getTemplateViewModel().quizPagination.pageMax(totalPage);
        this.getTemplateViewModel().quizPagination.pageNumber(currentPage);
    }

    public show() {
        this.refreshQuizDynamicPlacementDefaults();
        if (!document.body.classList.contains("is-fixed")) {
            document.body.classList.add("is-fixed");
        }
        this.getTemplateViewModel().isShown(true);
    }

    public hide() {
        this.disableQuizWaypoint();
        document.body.classList.remove("is-fixed");
        this.getTemplateViewModel().isShown(false);
    }

    public showLoading() {
        this.getTemplateViewModel().isLoading(true);
    }

    public hideLoading() {
        this.getTemplateViewModel().isLoading(false);
    }

    public enableQuizWaypoint() {
        if (this.quizLoadEnabled) {
            return;
        }

        const div = document.getElementById("quiz-results-list");
        if (!div) {
            return;
        }

        this.quizScrollContainer = div;
        this.quizScrollHandler = () => {
            if (this.quizScrollDebounceTimeout !== null) {
                window.clearTimeout(this.quizScrollDebounceTimeout);
            }

            this.quizScrollDebounceTimeout = window.setTimeout(() => {
                this.quizScrollDebounceTimeout = null;
                this.handleQuizResultsScroll(div);
            }, 150);
        };

        div.addEventListener("scroll", this.quizScrollHandler);

        this.quizLoadEnabled = true;
    }

    protected disableQuizWaypoint(): void {
        if (this.quizScrollDebounceTimeout !== null) {
            window.clearTimeout(this.quizScrollDebounceTimeout);
            this.quizScrollDebounceTimeout = null;
        }

        if (this.quizScrollContainer && this.quizScrollHandler) {
            this.quizScrollContainer.removeEventListener("scroll", this.quizScrollHandler);
        }

        this.quizScrollContainer = null;
        this.quizScrollHandler = null;
        this.quizLoadEnabled = false;
    }

    protected handleQuizResultsScroll(div: HTMLElement): void {
        const pagination = this.getTemplateViewModel().quizPagination;
        const currentPage = Number(pagination.pageNumber());
        const pageMax = Number(pagination.pageMax());
        const isNearBottom =
            div.scrollTop > 0 &&
            div.scrollTop + div.clientHeight >= div.scrollHeight - 100;

        if (
            !this.getTemplateViewModel().isShown() ||
            !document.body.classList.contains("is-fixed") ||
            !isNearBottom ||
            this.quizNextpageRequested ||
            currentPage >= pageMax
        ) {
            return;
        }

        this.quizNextpageRequested = true;
        pagination.pageNumber(currentPage + 1);

        if (this.caller.getQuizData) {
            this.caller.getQuizData();
        } else {
            this.quizNextpageRequested = false;
        }
    }

    protected filterSimpleOnChange() {
        this.resetPagination();
        this.caller.getQuizData();
    }

    protected filterSimpleCancel() {
        if (this.caller.filterSimpleCancel) {
            this.caller.filterSimpleCancel();
        }
    }

    protected onClickQuiz(quiz) {
        if (this.caller.getQuizForPicker) {
            this.caller.getQuizForPicker(quiz.id);
            return;
        }

        this.setQuiz(quiz);
    }

    protected onClickQuickEditQuiz(quiz) {
        if (this.caller.getQuizForPicker) {
            this.caller.getQuizForPicker(quiz.id, true);
            return;
        }

        this.editQuiz(quiz);
    }

    protected onClickQuickInsertQuiz(quiz) {
        this.insertQuiz(quiz, this.getIsQuizDynamicPlacement());
    }

    protected onClickAddQuiz() {
        this.quizView.hide();
        this.quizEdit.setQuiz(this.getNewQuizFromCurrentArticle());
        this.quizEdit.show();
    }

    /**
     * Only switches to the edit form once generation has succeeded: QuizController rejects source
     * articles under its minimum content length, and the picker's list should stay visible (with the
     * error popup) rather than open an empty edit form for a quiz that was never generated or saved.
     */
    protected onClickGenerateAndEditQuiz() {
        this.quizView.hide();
        this.generateQuizFromArticle(this.getNewQuizFromCurrentArticle());
    }

    /**
     * Only closes the picker once the initial insert/validate round trip has succeeded: a source
     * article under QuizController::getOrCreateForArticle's minimum content length leaves the picker
     * open on its list with the error popup already shown by insertGeneratedQuizFromPicker, instead
     * of closing on a request that inserted nothing.
     */
    protected async onClickGenerateAndInsertQuiz(): Promise<void> {
        if (!this.caller.insertGeneratedQuizFromPicker) {
            return;
        }

        const isInserted = await this.caller.insertGeneratedQuizFromPicker(
            this.target || "article_content",
            this.getIsQuizDynamicPlacement()
        );

        if (!isInserted) {
            return;
        }

        this.setQuizElement(null);
        this.quizView.hide();
        this.quizEdit.hide();
        this.hide();
    }

    protected getNewQuizFromCurrentArticle() {
        const sourceArticle = this.getCurrentArticleForQuiz();

        return {
            id: null,
            title: "",
            idSourceArticle: sourceArticle ? sourceArticle.id : null,
            idSourceArticleBrand: sourceArticle ? sourceArticle.idBrand : null,
            article: sourceArticle,
            brands: [],
            quiz: [],
        };
    }

    protected getCurrentArticleForQuiz() {
        if (this.caller.getCurrentArticleForQuizPicker) {
            return this.caller.getCurrentArticleForQuizPicker();
        }

        return null;
    }

    public insertQuiz(quiz, isQuizDynamicPlacement = null) {
        const shouldUseDynamicPlacement = isQuizDynamicPlacement === null
            ? this.getIsQuizDynamicPlacement()
            : !!isQuizDynamicPlacement;
        const elementToReplace = this.getQuizElement();
        const quizElement = this.buildQuizElement(quiz, shouldUseDynamicPlacement);
        this.caller.insertQuizElement(elementToReplace, quizElement, this.target);
        this.setQuizElement(null);
        this.quizView.hide();
        this.quizEdit.hide();
        this.hide();
    }

    public editQuiz(quiz) {
        this.quizEdit.setQuiz(quiz);
        this.quizEdit.show();
    }

    public saveQuiz(quiz, insertAfterSave = false, isQuizDynamicPlacement = null) {
        this.caller.saveQuizFromPicker(quiz, insertAfterSave, isQuizDynamicPlacement);
    }

    /**
     * @param draftQuiz Base fields for a fresh quiz to switch the edit form to once generation
     * succeeds (the "Generate & Edit" picker button). On failure the picker keeps its list visible
     * and the error is surfaced through a popup instead of opening the edit form.
     */
    public generateQuizFromArticle(draftQuiz: any = null) {
        this.caller.generateQuizFromArticleFromPicker(draftQuiz);
    }

    public setQuiz(quiz) {
        this.quizView.setQuiz(quiz);
        this.quizEdit.setQuiz(quiz);
        this.quizView.show();
    }

    public setQuizAfterSave(quiz) {

        this.updateQuizResult(quiz);
        this.quizView.setQuiz(quiz);
        this.quizEdit.setQuiz(quiz);
        if (quiz.isGenerated) {
            this.quizView.hide();
            this.quizEdit.show();
        } else {
            this.quizView.show();
            this.quizEdit.hide();
        }
    }

    protected updateQuizResult(quiz) {
        const quizResults = this.getTemplateViewModel().quizResults();
        const existingQuiz = quizResults.find((result) => result.id == quiz.id);

        if (existingQuiz) {
            existingQuiz.title = quiz.title || existingQuiz.title;
            existingQuiz.numberOfQuestions = quiz.numberOfQuestions || (quiz.quiz ? quiz.quiz.length : existingQuiz.numberOfQuestions);
            existingQuiz.numberOfRespondents = quiz.numberOfRespondents || existingQuiz.numberOfRespondents;
            existingQuiz.dateCreated = quiz.dateCreated || existingQuiz.dateCreated;
            this.getTemplateViewModel().quizResults([]);
            this.getTemplateViewModel().quizResults(quizResults);
        }
    }

    protected buildQuizElement(quiz, isQuizDynamicPlacement) {
        const id = quiz.id || "";
        const title = this.escapeHtml(quiz.title || "Quiz");
        const dynamicPlacementValue = isQuizDynamicPlacement ? "1" : "0";
        const insertToken = "quiz_insert_" + Date.now() + "_" + Math.random().toString(36).slice(2);

        return `<div class="emaki-displayCard quiz" data-widget-injection="quiz" data-id="${id}" data-dynamic-placement="${dynamicPlacementValue}" data-quiz-insert-token="${insertToken}" contenteditable="false">${title}</div>`;
    }

    protected escapeHtml(value: string): string {
        const div = document.createElement("div");
        div.textContent = value;
        return div.innerHTML;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/quizPicker_template.ts